import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { programDropzonesShow, programDropzonesHide  } from '../actions'


const mapDispatchToProps = dispatch => ({
    showDropzones: () => {
		dispatch(programDropzonesShow())
	},

	hideDropzones: () => {
		dispatch(programDropzonesHide())
	}
})


const hasDropzones = () => WrappedComponent => {
    const HasDropzones = props => <WrappedComponent {...props} />

    return compose(
        connect(null, mapDispatchToProps)
    )(HasDropzones)
}


export default hasDropzones